import React, { useState, useEffect } from 'react';
import { ArrowRight, Lock } from 'lucide-react';
import { dashboardSlides, stats } from '../data/projectsData';

function Hero({ onOpenQuote }) {
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => setCurrentSlide((p) => (p + 1) % dashboardSlides.length), 3500);
        return () => clearInterval(timer);
    }, []);

    return (
        <section id="home" className="pt-32 md:pt-40 pb-12 md:pb-20 px-4 md:px-6 relative overflow-hidden min-h-screen flex items-center">
            <div className="absolute top-[-10%] right-[-20%] w-[70vw] h-[70vw] bg-purple-200/30 rounded-full blur-3xl animate-blob pointer-events-none"></div>
            <div className="absolute bottom-[-10%] left-[-10%] w-[60vw] h-[60vw] bg-blue-200/30 rounded-full blur-3xl delay-700 animate-blob pointer-events-none"></div>
            
            <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 lg:gap-16 items-center relative z-10 w-full">
                <div className="space-y-6 md:space-y-8 text-center lg:text-left">
                    <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-blue-50 border border-blue-100 text-blue-700 text-[10px] md:text-xs font-bold uppercase tracking-wider">
                        <span className="relative flex h-2.5 w-2.5">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-blue-500"></span>
                        </span>
                        Now Serving East Africa
                    </div>
                    
                    <h1 className="text-4xl sm:text-5xl lg:text-7xl font-extrabold tracking-tight text-slate-900 leading-[1.1]">
                        Engineering the <br/> <span className="gradient-text">Digital Future.</span>
                    </h1>
                    
                    <p className="text-base md:text-lg text-slate-600 max-w-2xl mx-auto lg:mx-0 leading-relaxed">
                        From Education to Finance, Healthcare to ISPs. We build robust, scalable platforms that power the daily operations of modern organizations.
                    </p>
                    
                    <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                        <a href="#portfolio" className="px-6 md:px-8 py-3 md:py-4 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 transition-all shadow-xl shadow-blue-500/30 flex items-center justify-center gap-2 group">
                            View Our Work <ArrowRight className="group-hover:translate-x-1 transition-transform" size={18} />
                        </a>
                        <button onClick={onOpenQuote} className="px-6 md:px-8 py-3 md:py-4 bg-white text-slate-700 border border-slate-200 rounded-xl font-bold hover:bg-slate-50 transition-all">
                            Contact Sales
                        </button>
                    </div>
                    
                    <div className="pt-6 md:pt-8 border-t border-slate-200 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
                        {stats.map((stat, idx) => (
                            <div key={idx}>
                                <div className="text-xl md:text-2xl font-extrabold text-slate-900">{stat.value}</div>
                                <div className="text-[10px] md:text-xs font-semibold text-slate-500 uppercase tracking-wide">{stat.label}</div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="relative perspective-1000 mt-8 lg:mt-0">
                    <div className="absolute inset-0 bg-gradient-to-tr from-blue-600 to-purple-600 rounded-3xl rotate-3 opacity-20 blur-lg"></div>
                    <div className="bg-slate-900 rounded-xl shadow-2xl relative border border-slate-700 overflow-hidden flex flex-col h-[300px] sm:h-[400px] md:h-[500px]">
                        <div className="bg-slate-800 border-b border-slate-700 px-4 py-3 flex items-center gap-4 z-20">
                            <div className="flex items-center gap-2">
                                <div className="w-2.5 h-2.5 rounded-full bg-red-500"></div>
                                <div className="w-2.5 h-2.5 rounded-full bg-yellow-500"></div>
                                <div className="w-2.5 h-2.5 rounded-full bg-green-500"></div>
                            </div>
                            <div className="flex-1 bg-slate-900/50 rounded-md py-1 px-3 flex items-center justify-center gap-2 text-[10px] md:text-xs text-slate-400 font-mono border border-slate-700/50">
                                <Lock size={10} className="text-green-500" />
                                <span className="truncate max-w-[150px] md:max-w-none">{dashboardSlides[currentSlide].address}</span>
                            </div>
                        </div>
                        <div className="relative flex-1 bg-slate-900 overflow-hidden group">
                            {dashboardSlides.map((slide, index) => (
                                <div key={index} className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${index === currentSlide ? 'opacity-100' : 'opacity-0'}`}>
                                    <img src={slide.url} alt={slide.label} className="w-full h-full object-cover object-center opacity-80" loading="lazy" />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Hero;